import { DetailsForm } from ".";
import * as QS from "querystringify";
import * as React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import * as Comp from "../../../../components";
import { Paths } from "../../../../constants";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { AppState } from "../../../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
});

type OwnProps = RouteComponentProps<{}> & {
    abstract: M.Abstract.Abstract;
    eventId: number;
    type: M.Abstract.AbstractType;
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
};

interface OwnState {
    isNew: boolean;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class DetailsComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    private form: DetailsForm | null = null;

    public async componentDidMount() {
        this._isMounted = true;
        const isNew = (QS.parse(this.props.location.search) as any).new === "true";
        await this.setStateAsync({ ...this.state, isNew });
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        return <>
            <h1>
                <Link dangerouslySetInnerHTML={{ __html: this.props.abstract.title }} to={Paths.AdminAbstractDetails(this.props.eventId, this.props.abstract.guid)} />
            </h1>

            <DetailsForm
                abstract={this.props.abstract}
                api={this.props.api}
                eventId={this.props.eventId}
                type={this.props.type}
                onSubmit={(model, body) => this.onSubmit(model, body)}
                ref={(ref) => this.form = ref}
            />
        </>;
    }

    private async onSubmit(model: Forms.AdminAbstract.AbstractDetailsData, body: any) {
        if (!this.form)
            return;

        this.form.toggleProcessing(true);
        const guid = this.props.abstract.guid;
        const result = await this.props.api.post(Api.endpoints.admin.abstract.saveDetails.withUrlParams({ guid }), {
            body: JSON.stringify(body),
        });

        if (!this._isMounted || !this.form)
            return;

        this.form.toggleProcessing(false);

        if (result.isSuccess && result.data) {
            this.props.notifySuccess(`Abstract <strong>${result.data.title}</strong><br />has been successfully saved.`);
            this.props.goto(this.state.isNew
                ? Paths.AdminAbstractEditUploads(this.props.eventId, guid) + "?new=true"
                : Paths.AdminAbstractDetails(this.props.eventId, guid));
        }
        else {
            this.form.setFormErrors(M.Result.Result.errorsOrMessage(result), undefined, true);
        }
    }
}

export const Details: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(DetailsComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/edit/components/Details.tsx